import deepEqual from 'fast-deep-equal'
import React from 'react'
import { formatPlacementAdjustment } from '../../util/placement_adjustments'
import { BidHistoryTooltip } from '../bid_history_tooltip'

import { UpdateReportAdTypes } from '../../util/contstants'

export const resolvePlacement = (placement: string | null | undefined): string => {
    const normalizedPlacement = placement?.trim()
    if (!normalizedPlacement) {
        return 'None'
    }
    switch (normalizedPlacement.toLowerCase()) {
        case 'top of search on-amazon':
        case 'top of search':
            return 'Top of search'
        case 'detail page on-amazon':
        case 'detail on-amazon':
        case 'product page':
        case 'product detail page':
            return 'Product pages'
        case 'other on-amazon':
        case 'rest of search':
            return 'Rest of search'
        case 'off amazon':
        case 'off-amazon':
            return 'Off Amazon'
        default:
            return normalizedPlacement
    }
}

interface DailyBudgetChangeProps {
    campaign: any
    extra: any
    disabled: boolean
}

interface DailyBudgetState {
    budgetSaving: boolean
}

export class PlacementAdjustment extends React.Component<DailyBudgetChangeProps, DailyBudgetState> {
    state: { budgetSaving: boolean } = {
        budgetSaving: false,
    }

    constructor(props: DailyBudgetChangeProps) {
        super(props)
        this.state = {
            budgetSaving: false,
        }
    }

    shouldComponentUpdate(
        nextProps: Readonly<DailyBudgetChangeProps>,
        nextState: Readonly<any>,
    ): boolean {
        return (
            nextState.budgetSaving != this.state.budgetSaving ||
            !deepEqual(nextProps.campaign, this.props.campaign) ||
            !deepEqual(nextProps.extra, this.props.extra)
        )
    }

    render() {
        const { campaign } = this.props
        return (
            <BidHistoryTooltip id={campaign.campaign_id} type={UpdateReportAdTypes.Campaigns}>
                <span>
                    {formatPlacementAdjustment(campaign.percentage > 0 ? campaign.percentage : 0)}
                </span>
            </BidHistoryTooltip>
        )
    }
}
